module.exports = __webpack_public_path__ + "static/media/js-expert.bd76aa85.png";